
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xscmebmzpylhxglrvdcj.supabase.co'
// const supabaseKey = process.env.SUPABASE_KEY
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhzY21lYm16cHlsaHhnbHJ2ZGNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzQ5NjkzNTMsImV4cCI6MTk5MDU0NTM1M30.UHT8Buk9oetj0wBSou8WqFjU4RXkKeZnh5N8Sxabd8U"
const supabase = createClient(supabaseUrl, supabaseKey)

export default supabase;
